<div class="sx-custom-calendar-header">
    <button mat-icon-button [disabled]="disabledMinY" class="sx-custom-calendar-header__double-arrow" (click)="previousClicked('year')">
        <svg focusable="false" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41 L10.83 12z M22.41 7.41L21 6l -6 6 6 6 1.41 -1.41L17.83 12"></path>
        </svg>
    </button>
    <button [hidden]="hideMonthMovement" [disabled]="disabledMinM" mat-icon-button (click)="previousClicked('month')"
        class="sx-custom-calendar-header__arrow">
        <svg focusable="false" viewBox="0 0 24 24">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </svg>
    </button>
    <span class="sx-custom-calendar-header__label">{{periodLabel}}</span>
    <button [hidden]="hideMonthMovement" [disabled]="disabledMaxM" mat-icon-button (click)="nextClicked('month')" class="sx-custom-calendar-header__arrow">
        <svg focusable="false" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
        </svg>
    </button>
    <button mat-icon-button [disabled]="disabledMaxY" class="sx-custom-calendar-header__double-arrow" (click)="nextClicked('year')">
        <svg focusable="false" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z M17 6L15.59 7.41 20.17 12 l-4.58 4.59L17 18l6-6z"></path>
        </svg>
    </button>
</div>